import { isEmpty } from 'lodash';
import EquipmentInformation from './EquipmentInformation';
import SelectEquipmentWidget from './SelectEquipmentWidget';
import PropTypes from 'prop-types';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';
import { useSelector } from 'react-redux';

const MyEquipmentFilter = props => {
  const { equipmentList, model, serialNumber } = props;
  const selectedEquipment = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment
  );

  const {
    openAddDrawer,
    openEditDrawer,
    openSelectDrawer,
    getDrawerComponent
  } = useEquipmentDrawer();

  const hasEquipmentsToSelect = equipmentList && !isEmpty(equipmentList);

  return (
    <section className="mb-5">
      {model && <EquipmentInformation {...props} />}
      {!serialNumber && (
        <SelectEquipmentWidget
          hasEquipmentsToSelect={hasEquipmentsToSelect}
          openAddDrawer={openAddDrawer}
          openEditDrawer={openEditDrawer}
          openSelectDrawer={openSelectDrawer}
        />
      )}

      {getDrawerComponent({
        currentEquipment: selectedEquipment,
        myEquipmentList: equipmentList
      })}
    </section>
  );
};

MyEquipmentFilter.propTypes = {
  equipmentList: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool]))
  ),
  recordSetTotal: PropTypes.number,
  model: PropTypes.string,
  serialNumber: PropTypes.string,
  checked: PropTypes.bool,
  onCheck: PropTypes.func
};

export default MyEquipmentFilter;
